import React from 'react';
import { Box, HStack, VStack, Text } from '@chakra-ui/react';
import { HiOutlineSun, HiOutlineMoon } from 'react-icons/hi2';
import WhatsAppConnect from './WhatsAppConnect';
import { WHATSAPP_ENABLED } from '../featureFlags';

const ChatHeader = ({ botName, jobTitle, isDark, onToggleDark, colors, hasShadow, linkWhatsApp, conversationId }) => {
    return (
        <Box
            as="header"
            position="sticky"
            top={0}
            zIndex={10}
            bg={colors.headerBg}
            borderBottomWidth="1px"
            borderBottomColor={colors.headerBorder}
            px={4}
            pb={3}
            boxShadow={hasShadow ? '0 2px 8px rgba(0,0,0,0.08)' : 'none'}
            transition="box-shadow 0.2s"
            style={{ paddingTop: 'calc(env(safe-area-inset-top) + 0.75rem)' }}
        >
            <HStack justifyContent="space-between" alignItems="center" gap={2}>
                <HStack gap={3} minW={0}>
                    <Box
                        w={10}
                        h={10}
                        borderRadius="full"
                        bg={colors.avatarBg}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        flexShrink={0}
                    >
                        <Text color="white" fontWeight="bold" fontSize="sm">AI</Text>
                    </Box>
                    <VStack gap={0} alignItems="flex-start" minW={0}>
                        <Text
                            fontWeight="600"
                            fontSize="md"
                            color={colors.textPrimary}
                            lineHeight="1.2"
                            truncate
                            maxW="100%"
                        >
                            {botName}
                        </Text>
                        {jobTitle && (
                            <Text
                                fontSize="xs"
                                color={colors.textSecondary}
                                lineHeight="1.2"
                                truncate
                                maxW="100%"
                            >
                                {jobTitle}
                            </Text>
                        )}
                    </VStack>
                </HStack>

                <HStack gap={1} flexShrink={0}>
                    {WHATSAPP_ENABLED && linkWhatsApp && (
                        <WhatsAppConnect
                            linkWhatsApp={linkWhatsApp}
                            conversationId={conversationId}
                            colors={colors}
                        />
                    )}
                    <Box
                        as="button"
                        p={2}
                        borderRadius="md"
                        color={colors.iconColor}
                        cursor="pointer"
                        onClick={onToggleDark}
                        _hover={{ bg: isDark ? '#3F3F3F' : '#F0F0F0' }}
                        transition="background 0.15s"
                        aria-label={isDark ? 'Tryb jasny' : 'Tryb ciemny'}
                    >
                        {isDark ? <HiOutlineSun size={20} /> : <HiOutlineMoon size={20} />}
                    </Box>
                </HStack>
            </HStack>
        </Box>
    );
};

export default ChatHeader;
